export const ALERT_TABS = [
    { id: "news", translationKey: "activation.alerts.tabs.news" },
    { id: "socialMedia", translationKey: "activation.alerts.tabs.social" },
    { id: "ads", translationKey: "activation.alerts.tabs.ads" },
    { id: "websiteContent", translationKey: "activation.alerts.tabs.content" },
    { id: "seoAlerts", translationKey: "activation.alerts.tabs.seo" },
] as const;

export type TabItem = (typeof ALERT_TABS)[number];

export type AlertTabId = TabItem["id"];

export const DEFAULT_TAB: AlertTabId = "socialMedia";

const ALERT_TABS_WITHOUT_ADS: readonly TabItem[] = ALERT_TABS.filter((tab) => tab.id !== "ads");

export const getAvailableAlertTabs = (hasAdsIntelPackage: boolean): readonly TabItem[] =>
    hasAdsIntelPackage ? ALERT_TABS : ALERT_TABS_WITHOUT_ADS;
